import React from "react";
import cx from "classnames";

const ChallengeItemSmall = ({
	title,
	description,
	complete,
	className,
}: {
	title: string;
	description: string;
	complete: boolean;
	type: string;
	goal: number;
	progress: number;
	reward?: any;
	className?: string;
}) => {
	return (
		<div className={cx("item", "challenge", "small", className, { complete: complete })}>
			<div className="itemBody">
				<div className="title">{title}</div>
				<div className="meta">
					<div>{description}</div>
				</div>
			</div>
		</div>
	);
};

export default ChallengeItemSmall;
